import {solanamainnet, solanamainnetAddresses} from "@hyperlane-xyz/registry";
import { ChainMap, ChainMetadata, ExplorerFamily } from "@hyperlane-xyz/sdk";
import { ProtocolType } from "@hyperlane-xyz/utils";

// A map of chain names to ChainMetadata
// Chains can be defined here, in chains.json, or in chains.yaml
// Chains already in the SDK need not be included here unless you want to override some fields
// Schema here: https://github.com/hyperlane-xyz/hyperlane-monorepo/blob/main/typescript/sdk/src/metadata/chainMetadataTypes.ts
export const chains = {
    solanamainnet: {
        ...solanamainnet,
        // SVM chains require mailbox addresses for the token adapters
        mailbox: solanamainnetAddresses.mailbox,
        // Inserted custom RPC endpoint for Solana mainnet (GetBlock)
        rpcUrls: [
            { http: 'https://rpc.ankr.com/solana/89f1f6c49a654c7d12baa44be8b44b15311c45289aab04d1d892b866174d4f7f' },
            ...solanamainnet.rpcUrls,
        ],
    },
};
